import { useMutation } from '@tanstack/react-query'
import { HttpStatusCode } from 'axios'
import { t } from 'i18next'

import { PatchAtualizarClientesService } from '@/features/clientes/services/patch-atualizar-clientes.service'
import { atualizarClienteKeys } from '@/features/clientes/utils'
import { showToast } from '@/shared/lib/sonner'

type TAtualizarClienteParams = {
  id: string
  cpf: string
}

export const useMutationAtualizarClientes = () => {
  return useMutation({
    mutationKey: atualizarClienteKeys.atualizar(),
    mutationFn: async (params: TAtualizarClienteParams) => {
      const response = await new PatchAtualizarClientesService().execute(params.id, params.cpf)
      return response
    },
    async onSuccess() {
      showToast({
        message: t('simulador:salvar_simulacao.atualizar_cliente.sucesso.titulo'),
        variant: 'success',
        closeButton: true,
      })
    },
    onError() {
      if (HttpStatusCode.BadRequest) {
        showToast({
          message: t('simulador:salvar_simulacao.atualizar_cliente.erro.titulo'),
          variant: 'error',
          closeButton: true,
        })
        return
      }
      showToast({
        message: t('errors_gerais.padrao', { ns: 'common' }),
        variant: 'error',
      })
    },
  })
}
